<template>
  <layout-basic>
    <v-container>
      <section class="banner-text">
        <v-row class="text-center" align="center" justify="center">
          <v-col cols="12" md="12">
            <h1 class="banner-title font-sora">Request a Demo</h1>
            <p class="fs-22">
              Get your team on the right path and request a demo today!
            </p>
          </v-col>
        </v-row>
      </section>
      <section class="container-new pricing-section">
        <v-row>
          <v-col cols="12" md="6">
            <h1 class="font-sora contact-title">
              Contact our team of microlearning experts to receive a free
              demonstration of our product
            </h1>
            <p class="mt-4">
              <img class="mr-2" src="static/icons/envelope.png" /><a
                class="fs-22"
                href="mailto:help@improve.online"
                >help@improve.online</a
              >
            </p>
          </v-col>
          <v-col cols="12" md="6">
            <div class="relative">
              <v-content>
                <v-card class="elevation-12 contact-us-form" fill-height>
                  <v-card-text>
                    <v-form ref="form" @submit.prevent="submitForm">
                      <!-- Honeypot: off-screen, invisible to real users. Bots that auto-fill every field are dropped server-side. -->
                      <input type="text" v-model="company_website" name="company_website" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;opacity:0;overflow:hidden;" />
                      <p>First Name:</p>
                      <v-text-field
                        v-model="first_name"
                        :rules="[rules.required, rules.name]"
                        label="First Name:"
                        type="text"
                        placeholder="John"
                        solo
                      ></v-text-field>
                      <p>Last Name:</p>
                      <v-text-field
                        v-model="last_name"
                        :rules="[rules.required, rules.name]"
                        label="Last Name:"
                        type="text"
                        placeholder="Smith"
                        solo
                      ></v-text-field>
                      <p>Company Name:</p>
                      <v-text-field
                        v-model="company_name"
                        :rules="[rules.required]"
                        label="Company Name"
                        placeholder="Smith Inc"
                        solo
                      ></v-text-field>
                      <p>Email Address:</p>
                      <v-text-field
                        v-model="email"
                        :rules="[rules.required, rules.email]"
                        label="Email"
                        placeholder="johnsmith@email.com"
                        solo
                        type="email"
                      ></v-text-field>
                      <p>Message:</p>
                      <v-textarea
                        v-model="messages"
                        :rules="[rules.required]"
                        label="Messages"
                        placeholder="Hi, Hello, Bonjour"
                        solo
                      ></v-textarea>

                      <div id="newsletter">
                        <v-checkbox
                          style="box-shadow: none !important;"
                          v-model="newsletter"
                          :label="
                            `Sign up for our newsletter to receive the latest news from IMPROVE.`
                          "
                        ></v-checkbox>
                      </div>
                      <div class="text-center mt-10">
                        <v-btn :loading="loading" color="primary" type="submit">
                          Contact Us
                        </v-btn>
                      </div>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-content>
            </div>
          </v-col>
        </v-row>
      </section>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import AuthAPI from '@/Api/auth.js';

export default {
  name: 'Contact',
  data: () => ({
    errorMessages: {},
    password: '',
    email: '',
    first_name: '',
    last_name: '',
    company_name: '',
    messages: '',
    newsletter: false,
    company_website: '',
    successMessage:
      'We have notified our team with your request. Some one from our team will be in touch shortly.',
    loading: false,
    rules: {
      required: (value) => !!value || 'Required.',
      email: (value) => {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return pattern.test(value) || 'Invalid email.';
      },
      name: (value) =>
        (value && value.length >= 2) || 'Name must be at least 2 characters.',
    },
  }),
  metaInfo() {
    return {
        title: "Contact IMPROVE: UK's Leading Online Learning Solution for SMEs",
        meta: [
            // Meta Description
            { name: 'description', content: "Get in touch with IMPROVE to start your FREE 14-day trial. Contact us to learn more about the UK's #1 online learning platform designed specifically for SMEs." },
            
            // Keywords
            { name: 'keywords', content: "Contact IMPROVE, online learning platform, SME training, free trial, small business education, learning solutions, UK SME experts" },
            
            // Open Graph / Facebook Tags
            { property: 'og:title', content: "Contact IMPROVE: UK's Leading Online Learning Solution for SMEs" },
            { property: 'og:description', content: "Get in touch with IMPROVE to start your FREE 14-day trial. Contact us to learn more about the UK's #1 online learning platform designed specifically for SMEs." },
            { property: 'og:image', content: "https://www.improve.online/static/seo.png" },
            { property: 'og:type', content: 'website' },
            { property: 'og:url', content: 'https://www.improve.online/contact' },
            
            // Twitter Card Tags
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:title', content: "Contact IMPROVE: UK's Leading Online Learning Solution for SMEs" },
            { name: 'twitter:description', content: "Get in touch with IMPROVE to start your FREE 14-day trial. Contact us to learn more about the UK's #1 online learning platform designed specifically for SMEs." },
            { name: 'twitter:image', content: "https://www.improve.online/static/seo.png" }
        ],
        link: [
            // Canonical URL
            { rel: 'canonical', href: 'https://www.improve.online/contact' }
        ]
    };
  },
  components: {
    LayoutBasic,
  },
  methods: {
    submitForm() {
      if (this.$refs.form.validate()) {
        this.contactUs();
      }
    },
    contactUs() {
      this.loading = true;
      AuthAPI.contactUs({
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        company_name: this.company_name,
        messages: this.messages,
        newsletter: this.newsletter,
        company_website: this.company_website,
      })
        .then(() => {
          this.$snotify.success(this.successMessage);
          this.loading = false;
        })
        .catch((err) => {
          this.valid = false;
          this.loading = false;
          this.errorMessages = this.$gf.errorResponse(err);
        });
    },
  },
};
</script>
